import Playlists from "../components/playlists/Playlists.jsx"

const PlaylistsScreen = () => {
  return <Playlists />;
}
export default PlaylistsScreen